"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var ImageUrlUtil = /*#__PURE__*/function () {
  function ImageUrlUtil() {
    _classCallCheck(this, ImageUrlUtil);
  }

  _createClass(ImageUrlUtil, null, [{
    key: "resize",
    value: function resize(url) {
      var maxWidth = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '-';
      var maxHeight = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '-';
      var imgPrefix = "/img/";

      if (url === undefined || url === null || url.length == 0 || url.endsWith(".svg")) {
        return url;
      }

      var prefixes = [];
      prefixes.push("//static.test.aperza.com" + imgPrefix);
      prefixes.push("https://static.test.aperza.com" + imgPrefix);
      prefixes.push("//static.stg.aperza.com" + imgPrefix);
      prefixes.push("https://static.stg.aperza.com" + imgPrefix);
      prefixes.push("//static.aperza.com" + imgPrefix);
      prefixes.push("https://static.aperza.com" + imgPrefix);

      for (var _i = 0, _prefixes = prefixes; _i < _prefixes.length; _i++) {
        var prefix = _prefixes[_i];

        if (url.startsWith(prefix)) {
          return prefix.substring(0, prefix.length - imgPrefix.length) + "/" + maxWidth + "x" + maxHeight + "/img/" + url.substring(prefix.length);
        }
      }

      return url;
    }
  }]);

  return ImageUrlUtil;
}();

exports.default = ImageUrlUtil;